import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class ReceivedChequeTable extends Component {
  columns = [
    {
      path: "sr",
      label: "Sr#",
      width: "1",
    },
    {
      path: "date",
      label: "Date",
      width: "1",
    },
    {
      path: "client",
      label: "Client",
      width: "4",
    },
    {
      path: "mobile_no",
      label: "Mobile",
      width: "3",
    },
    {
      path: "description",
      label: "Description",
      width: "3",
    },
    {
      path: "attachment",
      label: "File",
      width: "1",
      content: (type) =>
        type.attachment == "" ? (
          <a
            className="ui"
            style={{
              backgroundColor: "red",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={"/pdc-cheques/received/" + type.id + "/edit"}
          >
            &nbsp;
          </a>
        ) : (
          <a
            className="ui"
            style={{
              backgroundColor: "green",
              color: "white",
              paddingLeft: "14px",
              height: "8px",
            }}
            href={
              process.env.REACT_APP_BACKEND_URL + "/storage/" + type.attachment
            }
          >
            &nbsp;
          </a>
        ),
    },
    {
      path: "amount",
      label: "Amount",
      width: "1",
    },
    {
      path: "status",
      label: "Status",
      width: "1",
      content: (type) =>
        type.status == 1 ? (
          <Label color="green">Received</Label>
        ) : (
          <Label color="red">Cleared</Label>
        ),
    },
    {
      key: "actions",
      width: "2",
      content: (type) => (
        <div>
          {/* {auth.getCurrentUser().email === "client-unblocker@gondalgroup.ae" && ( */}
          <React.Fragment>
            <Icon
              name={type.status == 1 ? "hide" : "eye"}
              color={type.status == 1 ? "black" : "green"}
              className="clickable"
              onClick={() => this.props.onStatusUpdate(type)}
            />
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />
            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </React.Fragment>
          {/* )} */}
          {/* <Icon
            name="info"
            color="blue"
            className="clickable"
            onClick={() => this.props.onDetail(type)}
          /> */}
        </div>
      ),
    },
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default ReceivedChequeTable;
